import { render } from "./LevelBoard.vue?vue&type=template&id=546822d2"
import script from "./LevelBoard.vue?vue&type=script&lang=js"
export * from "./LevelBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__